import { offer as EnUsOffer } from '../en-us/offer';
import { AgResourceLanguage } from '../types';

export const offer: AgResourceLanguage['offer'] = {
  ...EnUsOffer,
  offerPrice: {
    firstTimePurchaseIncludes: 'Erstkauf beinhaltet:',
    free: 'Kostenlos',
    total: 'Gesamt',
    valueOfOneTimePurchase: 'Wert bei einmaligem Kauf',
    firstMonthFree: 'Erhalte einen kostenlosen Monat AG1 + ein kostenloses Willkommenspaket',
    firstMonthFreeTag: 'Kostenloser erster Monat'
  }
};
